import React from 'react'
import { useSelector } from "react-redux"

const SOAP = () => {
    const Userdata = useSelector(({ auth }) => auth.UserData);

    const baseURL = useSelector(({ utils }) => utils.baseURL);
    const VerifyData = useSelector(({ auth }) => auth.VerifyData);
    const sypLogSummaryId = useSelector(({meeting})=>meeting.sypLogSummaryId)
    const PatientID = useSelector(({meeting})=>meeting.PatientID)

    
    return (
        <div style={{ width: "100%", height: "calc(100% - 67px)",padding:"10px",maxHeight:"calc(100% - 67px)"}}>
            <iframe
                id="videoRequestIframe"
                src={`${baseURL}/#/directlogin?pmid=${Userdata?.meetingInfo?.pmid}=&req=soapform&iframe=1&bookScheduleId=${VerifyData?.meetingBookScheduleId}&userId=${PatientID}&sypLogSummaryId=${sypLogSummaryId}`}
                height="100%"
                style={{ height: "100%", width: "100%", border: "0" }} ></iframe>
                
        </div>
    )
}

export default SOAP
